import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, filter, map } from 'rxjs';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { Category } from 'app/modules/contacts/contacts.types';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';

@Component({
  selector: 'app-custom-contact-category',
  templateUrl: './custom-contact-category.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomContactCategoryComponent extends OnDestroyMixin implements OnInit {
  public categories$: Observable<Category[]>;

  @Input() readonly: boolean;

  @Output() onValueChanged = new EventEmitter<{ category: Category; category_name: string; category_id: number }>();

  constructor(private readonly accountService: AccountService) {
    super();
  }

  ngOnInit(): void {
    this.getCategories();
  }

  private getCategories(): void {
    this.categories$ = this.accountService.categories$.pipe(
      untilComponentDestroyed(this),
      filter((categories) => !!categories),
      map((categories) => categories.filter((option) => !option.hidden)),
    );
  }

  public onCategorySelect({ value }: MatSelectChange): void {
    const categoryObj: Category = value;
    this.onValueChanged.emit({ category: categoryObj, category_name: categoryObj.name, category_id: categoryObj.id });
  }
}
